import { ActionType, createAsyncAction } from "typesafe-actions";

import { EntityTypesSupportingExport } from "@mapmycustomers/shared/types/entity";
import PlatformListRequest from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformListRequest";
import ViewState from "@mapmycustomers/shared/types/viewModel/ViewState";

export const exportEntities = createAsyncAction(
  "@exportEntities/download/request",
  "@exportEntities/download/success",
  "@exportEntities/download/failure"
)<
  {
    entityType: EntityTypesSupportingExport;
    exportCreationSuccessMessage?: string;
    name?: string;
    // Note: if you only use platformRequest and don't use viewState.filters, don't forget to include
    // special filters there to fetch all required columns, such as includeCustomFields, includeGroups, etc.
    platformRequest?: Partial<PlatformListRequest>;
    total?: number;
    viewState: Partial<ViewState>;
  },
  void,
  unknown
>();

export type Actions = ActionType<typeof exportEntities>;
